import React from "react";
// import imgOne from "../../assets/help-family.jpg";
// import imgTwo from "../../assets/call-support.jpg";

const AboutTwo = () => {
  return (
    <section className="bg-gray-50 py-16 px-6 lg:px-12 xl:px-20">
      <div className="max-w-7xl mx-auto space-y-20">
        {/* Section 1 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Text Content */}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">
              How the Birth Injury Justice Center Can Help
            </h2>
            <p className="text-gray-700 mb-4">
              The Birth Injury Justice Center has decades of experience representing
              families in birth injury cases resulting from medical negligence or
              improper care.
            </p>
            <p className="text-gray-700 mb-4">
              We have worked with many families affected by birth injuries to help
              them find answers to their birth injury legal questions. We have
              helped parents and caregivers take the next steps in{" "}
              <span className="font-semibold text-gray-900">
                getting the financial compensation they need to plan for their
                child’s future.
              </span>
            </p>
            <p className="text-gray-700">
              Our legal team is made up of nurse case managers, cerebral palsy
              attorneys, and other birth injury attorneys who strive to make a
              positive difference in the lives of others. We have helped people
              across the country get the legal support they need to move their
              birth injury claims through the court system successfully.
            </p>
          </div>

          {/* Image */}
          <div>
            <img
              src="https://img.freepik.com/free-photo/mother-with-her-baby-girl-home_1303-29021.jpg"
              alt="Family receiving legal help"
              className="w-full rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>

        {/* Callout Box */}
        <div className="bg-teal-100 border-l-4 border-teal-600 p-6 rounded-lg shadow-sm">
          <p className="text-gray-800 font-medium">
            Contact the Birth Injury Justice Center today at{" "}
            <a
              href="tel:8554502328"
              className="text-[#023437]  font-semibold hover:underline"
            >
              (888)-201-1350
            </a>{" "}
            to discuss your child’s birth injury and receive a free case review.
          </p>
        </div>

        {/* Section 2 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Text Content */}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">
              What to Expect When You Call the Birth Injury Justice Center
            </h2>
            <p className="text-gray-700 mb-4">
              If they suspect your child’s birth injury was caused by medical
              negligence,{" "}
              <span className="font-semibold text-gray-900">
                you may be able to take legal action.
              </span>
            </p>
            <p className="text-gray-700 mb-4">
              Caring for a child with a birth injury can be exhausting and
              overwhelming. You may not know where to turn for answers.
            </p>
            <p className="text-gray-700">
              The professionals at the Birth Injury Justice Center are here to
              help ease your mind. Our registered nurse is here to answer your
              questions and discuss any of your concerns, including possible signs
              of birth injuries in infants and children.
            </p>
          </div>

          {/* Image + Callout */}
          <div className="space-y-4">
            <img
              src="https://img.freepik.com/free-photo/front-view-mother-holding-newborn-baby_23-2150227213.jpg?ga=GA1.1.1620572362.1757502533&semt=ais_hybrid&w=740&q=80"
              alt="Mother calling for support"
              className="w-full rounded-2xl shadow-lg object-cover"
            />
            <div className="bg-[#023437]  text-white p-6 rounded-lg shadow-md">
              <p className="font-medium">
                If you believe your child’s birth injury was the result of medical
                negligence or improper medical care,{" "}
                <a href="#" className="underline hover:text-teal-200">
                  call today.
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTwo;
